class AssessmentsButtonController {

    private shown: boolean;
    private onShow: any;

    /* @ngInject */
    constructor(private $log: ng.ILogService) {
    }

    public showAssessments() {
        this.$log.debug("showAssessments");

        this.onShow({
            $event: {}
        });
    }

}

export const AssessmentsButtonComponent: angular.IComponentOptions = {
    bindings: {
        shown: "<",
        onShow: "&"
    },
    controller: AssessmentsButtonController,
    template: `
            <a href="#"
               role="button"
               aria-label="Assessments"
               aria-expanded="{{$ctrl.shown}}"
               uib-tooltip="Assessments"
               tooltip-placement="bottom"
               ng-class="{'active': $ctrl.shown}"
               ng-click="$ctrl.showAssessments()">
                <i class="material-icons">assessment</i>
            </a>
        `
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/button/assessments-button.component.ts